module.exports = __webpack_public_path__ + "img/confinedspaces.294c69a2.png";